import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { YAGA_EXTERNALS } from '../../config/fe-routes';
import useUser from '../../hooks/useUser';
import UserService from '../../services/user.service';
import Button from '../ui-kit/Button/Button';
import Modal from '../ui-kit/Modal/Modal';

const userService = new UserService();

export const TermsUpdateModal = () => {
  const { user, refreshUser } = useUser();
  const { t } = useTranslation();

  const [isVisible, setVisible] = useState(false);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (user?.isLoggedIn) {
      setVisible(!!user.onboardingWebCompleted && !!user.requiresTermsAcceptance);
    }
  }, [user]);

  const handleAgree = async () => {
    setLoading(true);
    try {
      await userService.acceptTerms();
      await refreshUser();
    } finally {
      setLoading(false);
    }
  };

  if (!user?.isLoggedIn) {
    return null;
  }

  return (
    <Modal
      open={isVisible}
      onClose={() => {
        // The user must accept the terms to close the modal
      }}
      showCloseButton={false}
      className="terms-update-modal"
      title={t('components.terms-update.title')}
      actions={
        <Button buttonType="primary" size="large" fullWidth key="terms-update-agree" disabled={isLoading} onClick={handleAgree}>
          {t('components.terms-update.cta')}
        </Button>
      }
    >
      <div className="terms-update-modal__body">
        <p>{t('components.terms-update.paragraph-1')}</p>
        <p
          dangerouslySetInnerHTML={{
            __html: t('components.terms-update.paragraph-2-web', {
              termsUrl: YAGA_EXTERNALS.TERMS().href,
              privacyUrl: YAGA_EXTERNALS.PRIVACY_POLICY().href,
            }),
          }}
        />
        <p>{t('components.terms-update.paragraph-3')}</p>
        <p>{t('components.terms-update.paragraph-4')}</p>
      </div>
    </Modal>
  );
};
